// extracted by mini-css-extract-plugin
module.exports = {"dropdownItem":"Navigator_dropdownItem__LBYtB","mslLink":"Navigator_mslLink__354i2"};